import { Link, useLocation } from "react-router-dom";
import React, { useEffect, useState } from 'react';
import CacheExtension from "../../StarterKit/Filter/CacheExtension";
import '../../styles/navbar.css';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import 'bootstrap/dist/css/bootstrap.css';
import HelperService from "../Services/Bll/HelperService";

export const NavigationBar = () => {
  const location = useLocation(); // once ready it returns the 'window.location' object
  const [url, setUrl] = useState(null);
  useEffect(() => {
    setUrl(location.pathname);
  }, [location]);

    // sessionStorage['profile']
  return (
    <>
      <Navbar bg="light" data-bs-theme="light">
          <Navbar.Brand to="/">Dataviz</Navbar.Brand>
          <Nav className="container-fluid">
              <Nav.Link className={"underline" + (url === "/ca" ?" active" : "")} href="/ca"><span class="longLabel">CA</span><span class="shortLabel">€</span></Nav.Link>
              <Nav.Link className={"underline" + (url === "/ca_detail" ?" active" : "")} href="/ca_detail"><span class="longLabel">Graphiques</span><span class="shortLabel">Graph</span></Nav.Link>
            {/*  <Nav.Link className={"underline" + (url === "/marge" ?" active" : "")} href="/marge"><span class="longLabel">Marge</span><span class="shortLabel">%</span></Nav.Link>*/}
            {/*<Nav.Link className={"underline" + (url === "/achats" ?" active" : "")} href="/achats">Achats</Nav.Link>*/}
            <Nav.Link className={"underline" + (url === "/pax" ?" active" : "")} href="/pax">PAX</Nav.Link>
              {sessionStorage["profile"] === "admin" && (
                  <Nav.Link
                      className="ms-auto backOfficeButton"
                      href={
                          window.location.href.includes("localhost")
                              ? "http://localhost:3001/login"
                              : window.location.href.includes("preprod")
                                  ? "https://preprod.solea-soleaviz-back.diji-dev.fr"
                                  : "https://soleaviz-back.diji.fr"
                      }
                  >
                      Back Office
                  </Nav.Link>
              )}
              {sessionStorage["profile"] !== "admin" && (
                  <Nav.Link
                      className="ms-auto"
                      disabled
                  >
                  </Nav.Link>
              )}
              <Nav.Link className="border-left pl-2 ml-auto" href="logout"><span
                  className="longLabel">Se déconnecter</span><span className="shortLabel">Déco</span></Nav.Link>
          </Nav>
      </Navbar>
    </>);
}
